import React from 'react';

const FieldList = ({data}) => {
    if (data.length === 0) {
        return (
            <div className="p-4">
                <p className="text-center text-sm leading-5 text-gray-900">There is no data available.</p>
            </div>
        )
    }

    return (
        <div className="px-4 py-5 sm:p-0">
            <dl>
                {data
                    .filter(item => !!item && typeof item?.label !== undefined && typeof item?.value !== undefined)
                    .map((item, key) => (
                        <div
                            className="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                            key={key}
                        >
                            <dt className="text-sm leading-5 font-medium text-gray-500">
                                {item.label}
                            </dt>
                            <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                                {item.value}
                            </dd>
                        </div>
                    ))}
            </dl>
        </div>
    );
}

export default FieldList;
